export const colors = [
    { color: ['556B2F','008000','03C03C','B2EC5D'], key : 1},
    { color: ['701C1C','B22222','D73B3E','FF0000'], key : 2},
    { color: ['556B2F','008000','03C03C','B2EC5D'], key : 3},
    { color: ['B5A642','E4D00A','FFEF00','FDFD96'], key : 4},
    { color: ['002366','002FA7','0000FF','92A1CF'], key : 5},
    { color: ['fd9f9f','f49191','ec8484','d87777'], key : 6},
    { color: ['2dfff','e7c5fb','d5a4f0','c48ff2'], key : 7},
    { color: ['cefafb','b9f9fb','98f6f9','72f6fb'], key : 8},
    { color: ['002366','002FA7','0000FF','92A1CF'], key : 9},
    { color: ['002366','002FA7','0000FF','92A1CF'], key : 10},
];



// WEBPACK FOOTER //
// ./src/components/Prioritizer/constants.js